<template>
  <div
    class="hero-wrapper"
    id="top"
  > 
    <div class="hero">
      <div class="container">
        <div class="text text-center text-lg-left">
          <router-link
            :to="'/berita/'+headline.slug"
            class="headline"
            v-if="headline"
          >
            <div class="badge badge-danger">
              New
            </div>
            {{ headline.judul_berita }} &nbsp; <i class="fas fa-chevron-right" />
          </router-link>
          <h1>{{ dataHero.title }}</h1>
          <p class="lead">
            {{ dataHero.desc }}
          </p>
          <div
            class="cta"
            v-if="dataHero.action === 'login'"
          >
            <a
              href="/login"
              class="btn btn-lg btn-warning btn-icon icon-right"
            >Login <i class="fas fa-chevron-right" /></a> &nbsp;
          </div>
          <div
            class="cta"
            v-if="dataHero.action === 'daftar'"
          >
            <a
              href="/register"
              class="btn btn-lg btn-warning btn-icon icon-right"
            >Daftar <i class="fas fa-chevron-right" /></a> &nbsp;
          </div>
        </div>
        <div
          class="image d-none d-lg-block"
          v-if="dataHero.img === 'home'"
        >
          <img
            :src="require('@/assets/img/ill.svg')"
            alt="img"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .hero-wrapper {
      display: inline-block;
      width: 100%;
      height: 580px;
  }
  .hero {
    width: 100%;
    position: relative;
    color: #fff;
    padding:0;
}
.hero .container {
    display: flex;
    align-items: center;
    min-height: 650px;
}
.hero .text {
    padding: 160px 80px 100px 0;
}
.hero .image, .hero .text {
    color: #fff;
    flex-grow: 0;
    width: calc(100% / 2);
}
@media (min-width: 992px){
  .text-lg-left {
    text-align: left!important;
    }
}
.hero .image {
    padding-left: 40px;
}
.hero .headline {
    display: inline-block;
    background-color: rgba(255,255,255, .1);
    color: #FFF;
    border-radius: 30px;
    padding: 5px 25px 5px 5px;
    font-size: 12px;
    margin-bottom: 40px;
    font-weight: 600;
    letter-spacing: .2px;
}
.hero .text h1 {
    font-weight: 700;
    line-height: 54px;
}
.hero .text p.lead {
    color: rgba(255,255,255,.8);
    font-weight: 500;
    line-height: 32px;
    margin-top: 15px;
    font-size: 18px;
}
.hero-mini .cta, .hero .cta {
    margin-top: 40px;
}
.hero-mini .btn, .hero .btn {
    font-size: 16px;
    border-radius: 30px;
    padding: 12px 30px;
    box-shadow: 0 0 30px rgb(252 189 37 / 40%);
}
.btn-warning, .btn-warning.disabled {
    box-shadow: 0 2px 6px #ffc473;
    background-color: #ffa426;
    border-color: #ffa426;
    color: #fff;
}
.hero .text-job {
    color: rgba(255,255,255,.6);
}
.text-job {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    color: #34395e;
}
.hero .image img {
    width: 100%;
}

.hero:after {
    width: 100%;
    border-radius: 0;
    transform: skewY(-5deg);
}

@media screen and (max-width: 992px){
    .hero .text {
        width: 100%;
        padding-right: 0;
        padding: 0;
    }
}
@media screen and (max-width: 768px){
    .hero .container {
        padding-top: 120px;
        padding-bottom: 40px;
        height: auto;
        min-height: auto;
    }
}

@media screen and (max-width: 425px) {
    .hero .text h1 {
        font-size: 28px;
        line-height: 42px;
    }
    .hero .text p.lead {
        font-size: 14px;
    }
    .hero .cta {
        margin-top: 20px;
    }
    .hero .btn {
        font-size: 14px;
        padding: 8px 20px;
    }
}

</style>

<script>

export default {
    data(){
        return {
            headline: null
        }
    },
    props: {
      dataHero: {
        type: Object,
        default: () => null
      }
    },
    created(){
        this.$store.dispatch('fetchBeritaHeadline').then(res => {
            if(res.data.status){
                this.headline = res.data.data
            }
        })
    }
}
</script>